import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { delay: { type: Number, default: 4000 } }
  declare delayValue: number

  connect(): void {
    setTimeout(() => this.dismiss(), this.delayValue)
  }

  dismiss(): void {
    this.element.animate([{ opacity: 1 }, { opacity: 0 }], { duration: 300 }).onfinish = () => {
      this.element.remove()
    }
  }
}
